"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LetterIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var utils_1 = require("../../utils");
exports.LetterIcon = function (_a) {
    var children = _a.children, _b = _a.color, color = _b === void 0 ? utils_1.theme.colors.NTDarkGrey[100] : _b, rest = tslib_1.__rest(_a, ["children", "color"]);
    return (react_1.default.createElement(StyledIcon, tslib_1.__assign({ color: color }, rest), children));
};
exports.default = exports.LetterIcon;
var StyledIcon = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  height: 1.6rem;\n  min-width: 1.6rem;\n  background-color: ", ";\n  font-family: ", ";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  align-self: flex-start;\n"], ["\n  height: 1.6rem;\n  min-width: 1.6rem;\n  background-color: ", ";\n  font-family: ", ";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  align-self: flex-start;\n"])), function (_a) {
    var color = _a.color;
    return color;
}, utils_1.theme.fonts.robotoMonoBold);
var templateObject_1;
